import { getCookieByName } from '@helpers/session'
import { SELECTED_COUNTRY_COOKIE, SELECTED_CURRENCY_COOKIE } from '@consts/index'

export function getSelectedCurrency(): string | undefined {
  return getCookieByName(SELECTED_CURRENCY_COOKIE) || undefined
}

export function getSelectedCountry(): string | undefined {
  return getCookieByName(SELECTED_COUNTRY_COOKIE) || undefined
}
